import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import FounderStory from './components/FounderStory';
import AtelierExperience from './components/AtelierExperience';
import { setPageMeta, injectJsonLd, removeJsonLd } from '../../utils/seo';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    const siteUrl = import.meta.env.VITE_SITE_URL || '';
    
    // Set page meta tags
    setPageMeta(
      'About Vionne | Founder Story & Atelier Experience',
      'Meet the founder of Vionne Stability and discover our unique atelier approach to acupuncture and facial structure regulation. Learn about our philosophy and commitment to nervous system wellness.',
      `${siteUrl}/about`
    );

    // Inject JSON-LD schema
    const schema = [
      {
        '@context': 'https://schema.org',
        '@type': 'Person',
        '@id': `${siteUrl}/about#founder`,
        name: 'Vionne',
        jobTitle: 'Founder & Acupuncturist',
        worksFor: {
          '@type': 'Organization',
          name: 'Vionne Stability',
          url: siteUrl
        },
        description: 'Founder of Vionne Stability, specializing in nervous system regulation and facial structure acupuncture for high-functioning women',
        url: `${siteUrl}/about`,
        knowsAbout: [
          'Acupuncture',
          'Nervous System Regulation',
          'Facial Structure Optimization',
          'Traditional Chinese Medicine',
          'Holistic Wellness'
        ],
        alumniOf: {
          '@type': 'EducationalOrganization',
          name: 'Acupuncture & Traditional Chinese Medicine Program'
        }
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        '@id': `${siteUrl}/#organization`,
        name: 'Vionne Stability',
        url: siteUrl,
        logo: 'https://public.readdy.ai/ai/img_res/b92888d44215de77156c22060d40d3fa.jpg',
        description: 'Premium acupuncture atelier specializing in nervous system regulation and facial structure optimization',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Vancouver',
          addressRegion: 'BC',
          addressCountry: 'CA'
        },
        founder: {
          '@type': 'Person',
          name: 'Vionne',
          '@id': `${siteUrl}/about#founder`
        },
        foundingDate: '2020',
        areaServed: {
          '@type': 'City',
          name: 'Vancouver',
          '@id': 'https://en.wikipedia.org/wiki/Vancouver'
        }
      }
    ];

    injectJsonLd(schema);

    return () => {
      removeJsonLd();
    };
  }, []);

  return (
    <div className="min-h-screen bg-warmWhite">
      <Navbar />
      <main>
        <AboutHero />
        <FounderStory />
        <AtelierExperience />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;